
import { post, get, getCookie, api_token, token, DEV_TOKEN } from './api.js';
import { getUser } from './user.js';
import { writable } from 'svelte/store';

let weddings;
export function getWeddings() {
    if (!weddings) {
        subscribeToUser();
        weddings = {
            organizing: writable([]),
            attending: writable([])
        }
    }
    return weddings;
}

let unsubscribe;
function subscribeToUser() {
    if (!unsubscribe) {
        unsubscribe = getUser().subscribe(promise => {
            promise
                .then(() => load())
                .catch(e => {
                    weddings.organizing.set([]);
                    weddings.attending.set([]);
                });
        });
    }
}

export async function load() {

    get('weddings/', token || DEV_TOKEN)
        .then(r => {
            weddings.organizing.set(r.data);
        })
        .catch(e => {
            weddings.organizing.set([]);
        });

    get('weddings_users/', token || DEV_TOKEN)
        .then(r => {
            weddings.attending.set(r.data);
        })
        .catch(e => {
            weddings.attending.set([]);
        });
}

/**
 * Create Wedding.
 */
export function create(weddingDate, weddingPlace, firstname, lastname, coFirstname, coLastname) {
    return post('weddings/',
        {
            weddingDate: weddingDate,
            weddingPlace: weddingPlace,
            firstname: firstname,
            lastname: lastname,
            coFirstname: coFirstname,
            coLastname: coLastname
        }, token || DEV_TOKEN);
}

export function check(invitation_code, wedding_code) {
    return post('wedding_check/',
        {
            invitation_code: invitation_code,
            wedding_code: wedding_code
        }, token || DEV_TOKEN);
}

export function join(id, wedding_code, invitation_code) {
    return post('weddings_users/',
        {
            id: id,
            code: wedding_code,
            invitation_code: invitation_code
        }, token || DEV_TOKEN);
}

export function isJoined(id) {
    return get(`weddings_users/${id}`, token || DEV_TOKEN);
}

export function infoForBlog(guid) {
    return get(`weddings/${guid}`, token || DEV_TOKEN);
}

export function info(guid, edit) {
    if (edit === undefined || edit === null) {
        return get(`weddings/${guid}`, token || DEV_TOKEN);
    } else {
        return get(`weddings/${guid}?edit=${edit}`, token || DEV_TOKEN);
    }
}